import * as React from "react";

export class BackgroundImage extends React.Component {
    render() {
        const { className, src, component, file } = this.props;
        const path = file ?
            (component ?
                `/static/images/components/${component}/${file}`:
                `/static/images/base/${file}`):
            src;
        const style = {
            backgroundImage: `url('${path}')`
        };
        
        return (
            <div
                className={className}
                style={style}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./react/library/BackgroundImage.jsx